module.exports = __webpack_public_path__ + "img/IMG_0057_L_Foamcore_MockedUp.6eceae66.jpg";